import { render, staticRenderFns } from "./NegativeMargins.vue?vue&type=template&id=532c988a&"
import script from "./NegativeMargins.vue?vue&type=script&lang=js&"
export * from "./NegativeMargins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports